"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPluginResponseSchema = exports.ObsoletePluginResponseSchema = exports.ObsoletePluginRequestSchema = exports.UpdatePluginReponseSchema = exports.UpdatePluginRequestSchema = exports.UpdatePluginImageRequestSchema = exports.UpdatePluginGeneralRequestSchema = exports.Plugin = exports.CreatePluginReponseSchema = exports.CreatePluginRequestSchema = exports.CreateBusinessPluginRequestSchema = exports.CreateServicePluginRequestSchema = void 0;
const zod_1 = require("zod");
const credential_1 = require("../misc/credential");
const plugin_1 = require("../model/plugin");
//create plugin api type
exports.CreateServicePluginRequestSchema = plugin_1.ServicePluginSchema.omit({
    uuid: true, status: true, version: true, userId: true, createdAt: true
}).merge(zod_1.z.object({
    credential: credential_1.CredentialSchema
}));
exports.CreateBusinessPluginRequestSchema = plugin_1.BusinessPluginSchema.omit({ uuid: true, status: true, version: true, userId: true, createdAt: true });
exports.CreatePluginRequestSchema = zod_1.z.union([exports.CreateServicePluginRequestSchema, exports.CreateBusinessPluginRequestSchema]);
exports.CreatePluginReponseSchema = zod_1.z.object({ message: zod_1.z.string() });
//update plugin api type
exports.Plugin = zod_1.z.union([
    plugin_1.ServicePluginSchema.omit({ status: true, version: true, userId: true, createdAt: true }),
    plugin_1.BusinessPluginSchema.omit({ status: true, version: true, userId: true, createdAt: true })
]);
exports.UpdatePluginGeneralRequestSchema = zod_1.z.object({
    type: zod_1.z.literal("general"),
    pluginId: zod_1.z.string(),
}).merge(plugin_1.PluginGeneralSchema);
exports.UpdatePluginImageRequestSchema = zod_1.z.object({
    type: zod_1.z.literal("image"),
    pluginId: zod_1.z.string(),
    imageUrl: zod_1.z.string()
});
exports.UpdatePluginRequestSchema = zod_1.z.union([exports.UpdatePluginGeneralRequestSchema, exports.UpdatePluginImageRequestSchema]);
exports.UpdatePluginReponseSchema = zod_1.z.object({
    message: zod_1.z.string(),
    plugins: zod_1.z.array(exports.Plugin)
});
//obselete plugin api type
exports.ObsoletePluginRequestSchema = zod_1.z.object({ pluginId: zod_1.z.string() });
exports.ObsoletePluginResponseSchema = zod_1.z.object({
    message: zod_1.z.string(),
    plugins: zod_1.z.array(exports.Plugin)
});
//get plugin api type
exports.GetPluginResponseSchema = zod_1.z.array(exports.Plugin);
